/*
 * versionRedirect.js - used/called by index.html
 * 
 * Makes an AJAX call to get the version.json and redirects to gateway.html 
 * with version as query parameter to avoid cached content after upgrade.
 */

let versionUrl = "version.json?_=" + Date.now();
try {
    let xmlhttp = new XMLHttpRequest();
    // handling change of ready state (function has its own 'this')
    xmlhttp.onreadystatechange = function() {
        
        if (this.readyState == 4) { // AJAX response complete
            if (this.status == 200) { // AJAX request was successful
                let versionJson = JSON.parse(this.responseText);
                let release = versionJson.Release;
                if (release == null || release == undefined || release.length <= 0) {
                    let msg = "failed to read release from version.json";
                    console.error(msg);
                    // using alert, since basic functionality is not given
                    alert(msg);
                } else {
                    let newUrl = "gateway.html?ver=" + release;
                    if (window.location.search.length > 1) {
                        newUrl += "&" + window.location.search.substring(1);
                    }
                    newUrl += window.location.hash;
                    
                    window.location.assign(newUrl);
                }
            } else {
                let msg = "failed to get version.json from '" + versionUrl + "': " + this.status + " - " + this.statusText;
                console.error(msg);
                // using alert, since basic functionality is not given
                alert(msg);
            }
        }
    };
    xmlhttp.open("GET", versionUrl, true);
    xmlhttp.send();
} catch (ex) {
    console.error("error while getting version from '" + versionUrl + "': ", ex.message);
}
